module.exports = __webpack_public_path__ + "static/media/React.9ca6973d.png";